import { render, staticRenderFns } from "./DistrictLocationDetails.vue?vue&type=template&id=29e7852a"
import script from "./DistrictLocationDetails.vue?vue&type=script&lang=js"
export * from "./DistrictLocationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports